export default {
  title: 'Coordonnées bancaires',
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    success: 'Vos informations ont été enregistrées avec succès.',
  },
};
